// import React, { useState, useCallback } from "react";
// import { useDropzone } from "react-dropzone";
// import axios from "axios";
// import "./FileUpload.css";

// const FileUpload = () => {
//   const [file, setFile] = useState(null);
//   const [uploading, setUploading] = useState(false);
//   const [downloadURL, setDownloadURL] = useState("");

//   // Drag and Drop Handling
//   const onDrop = useCallback((acceptedFiles) => {
//     const selectedFile = acceptedFiles[0];
//     if (selectedFile.type === "application/pdf") {
//       setFile(selectedFile);
//     } else {
//       alert("Only PDF files are allowed!");
//     }
//   }, []);

//   const { getRootProps, getInputProps, isDragActive } = useDropzone({
//     onDrop,
//     accept: "application/pdf",
//   });

//   // Upload to Dropbox via Server
//   const handleUpload = async () => {
//     if (!file) {
//       alert("Please select a PDF file first.");
//       return;
//     }

//     setUploading(true);
//     const formData = new FormData();
//     formData.append("pdf", file);

//     try {
//       const response = await axios.post("http://localhost:5001/upload-nda", formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });

//       if (response.data.link) {
//         setDownloadURL(response.data.link);  // Dropbox shared link
//         alert("Upload successful!");
//       } else {
//         alert("Upload failed!");
//       }
//     } catch (error) {
//       console.error("Error uploading file:", error);
//       alert("Upload failed!");
//     } finally {
//       setUploading(false);
//     }
//   };

//   return (
//     <div className="upload-container">
//       <h2>Upload Signed NDA</h2>

//       {/* Drag & Drop Section */}
//       <div {...getRootProps()} className={`dropzone ${isDragActive ? "active" : ""}`}>
//         <input {...getInputProps()} />
//         {isDragActive ? <p>Drop the PDF here...</p> : <p>Drag & Drop a PDF or Click to Select</p>}
//       </div>

//       {/* File Preview */}
//       {file && <div className="file-preview"><p>📄 {file.name}</p></div>}

//       {/* Upload Button */}
//       <button onClick={handleUpload} disabled={uploading} className="upload-button">
//         {uploading ? "Uploading..." : "Upload"}
//       </button>

//       {/* Display Uploaded File Link */}
//       {/* {downloadURL && (
//         <div className="file-link">
//           <p>File uploaded successfully! You can download it from the link below:</p>
//           <a href={downloadURL} target="_blank" rel="noopener noreferrer">Download PDF</a>
//         </div>
//       )} */}
//     </div>
//   );
// };

// export default FileUpload;
import React, { useState, useCallback, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import axios from "axios";
import { auth } from "../firebaseConfig"; // Ensure the path is correct
import "./FileUpload.css";

const FileUpload = () => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [downloadURL, setDownloadURL] = useState("");
  const [username, setUsername] = useState("");

  // Fetch logged-in user from Firebase
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUsername(user.email.split("@")[0]); // Extract username from email
      } else {
        setUsername(""); // Reset if user logs out
      }
    });

    return () => unsubscribe(); // Cleanup on unmount
  }, []);

  // Drag & Drop Handling
  const onDrop = useCallback((acceptedFiles) => {
    const selectedFile = acceptedFiles[0];
    if (selectedFile.type === "application/pdf") {
      setFile(selectedFile);
    } else {
      alert("Only PDF files are allowed!");
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: "application/pdf",
  });

  // Upload File to Server
  const handleUpload = async () => {
    if (!file) {
      alert("Please select a PDF file first.");
      return;
    }

    const user = auth.currentUser; // Use auth instead of firebase.auth()
    if (!user) {
      alert("User not logged in.");
      return;
    }

    setUploading(true);
    const formData = new FormData();
    formData.append("pdf", file);
    formData.append("username", username); // Use extracted username

    try {
      const response = await axios.post("https://databoltahi.com/upload-nda", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.path) {
        alert("Upload successful!");
        setDownloadURL(response.data.path);
      } else {
        alert("Upload failed!");
      }
    } catch (error) {
      console.error("Error uploading file:", error.response?.data || error.message);
      alert("Upload failed!");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="upload-container">
      <h2>Upload Signed NDA</h2>
      <p>Logged in as: <strong>{username || "Not logged in"}</strong></p>

      <div {...getRootProps()} className={`dropzone ${isDragActive ? "active" : ""}`}>
        <input {...getInputProps()} />
        {isDragActive ? <p>Drop the PDF here...</p> : <p>Drag & Drop a PDF or Click to Select</p>}
      </div>

      {file && <div className="file-preview"><p>📄 {file.name}</p></div>}

      <button onClick={handleUpload} disabled={uploading} className="upload-button">
        {uploading ? "Uploading..." : "Upload"}
      </button>

      {downloadURL && <a href={downloadURL} target="_blank" rel="noopener noreferrer">Download PDF</a>}
    </div>
  );
};

export default FileUpload;
